module.exports = __webpack_public_path__ + "img/naira.508561f7.svg";